export default __webpack_public_path__ + "static/media/blogcard.a524a19d.jpg";